import {Button, Col, Layout, Row, Space, Steps} from 'antd';
import {useEffect, useMemo, useState} from 'react';
import {useTranslation} from 'react-i18next';
import {capitalize} from 'lodash';
import {EditAssetPositionFormCard} from '../components/editAsset/EditAssetPositionFormCard';
import {EditAssetDetailFormCard} from '../components/editAsset/EditAssetDetailFormCard';
import {EditAssetRealEstateFormCard} from '../components/editAsset/EditAssetRealEstateFormCard';
import {useEditFormContext} from '../context/editAsset/EditAssetFormContext';
import {DocumentsListCard} from '../components/asset/cards/DocumentsListCard';
import {ImagesListCard} from '../components/asset/cards/ImagesListCard';
import PermissionRoute from '../components/Authentication/PermissionRoute';
import {isGeolocationAutomaticAssetEdit, isUserCreatedAssetEdit} from '../components/Authentication/permissions';
import {useAssetDetails} from '../context/assetDetails/AssetDetails';
import {CustomSider} from '../components/common/CustomSider';
import {useParams} from "react-router-dom";

const {Content} = Layout;
export const EditAsset = () => {

  const {assetId} = useParams();
  const [setAssetUuid] = useAssetDetails();

  const {t} = useTranslation();
  const {isFirstStepComplete, isSecondStepComplete, isThirdStepComplete, submit} = useEditFormContext();
  const [, {asset}] = useAssetDetails();
  console.log('assetId', assetId)

  useEffect(() => {
    if (assetId) {
      setAssetUuid(assetId);
    }
  }, [assetId, setAssetUuid]);

  const [
    currentStep,
    setCurrentStep,
  ] = useState(0);

  const steps = useMemo(() => ([
    {
      title: `${capitalize(t('form.edit'))} ${t('assets.buildingLocation')}`,
    },
    {
      title: `${capitalize(t('form.edit'))} ${t('assets.buildingDetails')}`,
    },
    {
      title: `${capitalize(t('form.edit'))} ${t('assets.realEstateData')}`,
    },
    {
      title: capitalize(t('documents.documentsAndImages')),
    },
  ]), [t]);

  const items = useMemo(() => {
    const isNotUserCreated = !asset.is_user_created;

    return steps.map((item, index) => {
      return {
        key: item.title,
        title: item.title,
        disabled: isNotUserCreated && index > currentStep,
      };
    });
  }, [steps, currentStep, asset.is_user_created]);

  // console.log('asset.is_user_created', asset.is_user_created)
  return (
    <PermissionRoute
      isAuthorized={asset.is_user_created ? isUserCreatedAssetEdit : isGeolocationAutomaticAssetEdit}
      redirect={asset.is_user_created}
    >
      <Layout style={{position: 'relative'}}>
        <CustomSider
          backButtonLabel={capitalize(t('form.cancel'))}
          content={
            <Steps
              current={currentStep}
              items={items}
              size={'small'}
              labelPlacement={'horizontal'}
              direction={'vertical'}
              style={{padding: '0 1.5rem'}}
              onChange={setCurrentStep}
            />
          }
        />
        <Content style={{overflowY: 'scroll'}}>
          <div style={{margin: '1rem 1.5rem'}}>
            <Row gutter={[28, 28]}>
              <Col span={24}>
                <Space
                  direction={'vertical'}
                  style={{display: 'flex'}}
                  size={'large'}
                >
                  {currentStep === 0 && <EditAssetPositionFormCard/>}
                  {currentStep === 1 && <EditAssetDetailFormCard/>}
                  {currentStep === 2 && <EditAssetRealEstateFormCard/>}
                  {currentStep === 3 && (
                    <>
                      <DocumentsListCard/>
                      <ImagesListCard/>
                    </>
                  )}
                </Space>

              </Col>
            </Row>

            <Row justify={'end'} style={{marginTop: '1rem'}}>
              <Col>
                {currentStep > 0 && (
                  <Button
                    style={{margin: '0 8px'}}
                    disabled={currentStep === 0}
                    onClick={() => setCurrentStep(current => current - 1)}
                  >
                    {capitalize(t('form.previous'))}
                  </Button>
                )}
                {currentStep < steps.length - 1 && (
                  <Button
                    type="primary"
                    disabled={!asset.is_user_created || (currentStep === 0 ? !isFirstStepComplete() : !isSecondStepComplete())}
                    onClick={() => setCurrentStep(current => current + 1)}
                  >
                    {capitalize(t('form.next'))}
                  </Button>
                )}
                {currentStep === steps.length - 1 && (
                  <Button
                    type="primary"
                    disabled={!isThirdStepComplete()}
                    onClick={submit}
                  >
                    {capitalize(t('form.done'))}
                  </Button>
                )}
              </Col>
            </Row>
          </div>
        </Content>
      </Layout>
    </PermissionRoute>
  );
};